import { updateDomComponent } from '@theme/critical';

class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('.predictive-search');

        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            return;
        }

        this.getSearchResults(searchTerm);
    }

    async getSearchResults(searchTerm) {
        const url = `/search/suggest?q=${searchTerm}&resources[limit]=10&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,body,variants.sku`;
        await updateDomComponent(
            [{ source: '#predictive-search-results-list', target: '#predictive-search-results'}],
            ['predictive-search'],
            url,
            { mode: 'innerHtml', returnDocument: false }
        );
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}

if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
}